var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useGetReportsListQuery } from "@/store/api";
import { useEffect, useState } from "react";
import { ReportsListItem } from "./listItem";
import { LoaderImage } from "@/utils/loader";
export var ReportsList = function (_a) {
    var id = _a.id;
    var _b = useState([]), records = _b[0], setRecords = _b[1];
    var _c = useGetReportsListQuery({
        id: id,
    }), reportListresponse = _c.data, isLoading = _c.isLoading;
    useEffect(function () {
        if (reportListresponse) {
            var recordArray_1 = [];
            reportListresponse.data.map(function (item, index) {
                var data = [];
                data["records"] =
                    Object.values(item.records).map(function (rec) { return (__assign({}, rec)); }) || [];
                data["fields"] = item.fields;
                data["links"] = item.isLink;
                data["group"] = item.group;
                recordArray_1[index] = data;
            });
            setRecords(recordArray_1);
        }
    }, [reportListresponse]);
    return (_jsxs(_Fragment, { children: [isLoading && _jsx(LoaderImage, {}), _jsx("div", __assign({ className: "relative mr-2" }, { children: records.length > 0 &&
                    records.map(function (item) {
                        var _a, _b;
                        return (_jsx(_Fragment, { children: _jsx(ReportsListItem, { records: (_a = item.records) !== null && _a !== void 0 ? _a : [], perPage: 10, isSearch: false, columns: (_b = item.fields) !== null && _b !== void 0 ? _b : [], link: item.links, group: item.group }) }));
                    }) }))] }));
};
